<template>
    <span>
        <base-button class="btn-primary btn" :disabled="disabled" @click.native="viewItem">
            <slot name="modal-link"></slot>
        </base-button>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">VIEW AS</h4>
            <hr />
            <div class="container">
                <label for="User">Users</label>
                <base-input id="User" :error="getError('user')">
                    <v-select v-model="userId" name="user" :reduce="(user) => user.id" label="name" :options="approvedUsers"
                        placeholder="Select one"></v-select>
                </base-input>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4"
                        @click.native="modals.classic = false">
                        Close
                    </base-button>
                    <base-button type="primary" class="alert_footer_button btn_extra_small btn_info"
                        @click.native="submit">
                        Update
                    </base-button>
                </div>
            </template>
        </modal>

    </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { BaseButton, Modal } from '@/components'

export default {
    name: "order-report-grid-view-modal",
    props: {
        isIcon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modals: {
                classic: false,
            },
        };
    },
    components: {
        BaseButton,
        Modal
    },
    computed: {
        ...mapGetters({
            reports: "orderReport/reports",
            report: "orderReport/report",
            userIdFromStore: "orderReport/userId",
            approvedUsers: "users/approvedUsers",
        }),
        userId: {
            get() {
                return this.userIdFromStore
            },
            set(value) {
                this.$store.commit('orderReport/SET_USERID', value)
            }
        }
    },
    methods: {
        ...mapActions({
            getApprovedUsers: "users/getApprovedUsers",
            getReport: "orderReport/getReport",
            clear: "orderReport/clearReport",
            getReports: "orderReport/getReportsByUserId",
        }),
        viewItem() {
            let ctx = this;
            ctx.getApprovedUsers(true).then(() => ctx.modals.classic = true);
        },
        submit(e) {
            let ctx = this;
            ctx.getReports();
            ctx.modals.classic = false;
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        }
    }
}
</script>
